module.exports = __webpack_public_path__ + "static/media/RateFood_Intro.c90c9b1f.png";